import React, { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Link from "next/link";

import { getTextAppHost, URLS } from "@/shared/utils/url/url";

import Button from "@/shared/components/Button/Button";
import { useModalContext } from "@/shared/contexts/modal";
import useCookiesWithOptions from "@/shared/hooks/useCookiesWithOptions";
import { Container } from "@/components/index";

import styles from "./CookiesNotification.module.scss";

const CookiesNotification = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { pathname } = router;

  const { showDialog } = useModalContext();
  const isInEu = true; //useSelector((state) => state.settings.geoIpData.is_in_eu);
  const [cookie, setCookie] = useCookiesWithOptions(["cookiesNotify"]);
  const { cookiesNotify } = cookie;
  const [show, setShow] = useState(true);
  const [showCookiesNotification, setShowCookiesNotification] = useState(false);

  const onCloseClick = (event) => {
    event && event.preventDefault();
    // set maxAge property to 1 year
    setCookie("cookiesNotify", "1", {
      maxAge: 31104000,
    });
    setShow(false);
    return true;
  };

  const onClickDecline = () => {
    showDialog(t("decline_cookie_title"), t("decline_cookie_message"), onCloseClick, {
      positiveBtn: t("accept"),
      negativeBtn: t("decline_cookie_negative"),
      noCancelable: true,
      onCancel: () => {
        document.location.replace(getTextAppHost());
        return true;
      },
    });
  };

  useEffect(() => {
    const isPrivacyPolicyPage = pathname.includes(URLS.privacyPolicy);
    setShowCookiesNotification(!cookiesNotify && isInEu && show && !isPrivacyPolicyPage);
  }, [isInEu, cookiesNotify, show, pathname]);

  if (!showCookiesNotification) {
    return null;
  }

  return (
    <div className={styles["cookies-notification"]}>
      <Container className={styles["cookies-notification-wrapper"]}>
        <div className={styles["cookies-notification-content"]}>
          <div className={styles["cookies-notification-content-title"]}>
            {t("cookiesNotificationTitle")}
          </div>
          <div className={styles["cookies-notification-content-text"]}>
            {t("cookiesNotificationText")}{" "}
            <Link href={URLS.privacyPolicy}>
              {t("privacyPolicyText")}
            </Link>
            {"."}
          </div>
        </div>
        <div className={styles["cookies-notification-actions"]}>
          <Button
            color={Button.color.secondary}
            onClick={onClickDecline}
            className={styles["btn-cookies"]}>
            {t("decline")}
          </Button>
          <Button
            onClick={onCloseClick}
            className={styles["btn-cookies"]}>
            {t("accept")}
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default CookiesNotification;
